import { PaymentMethodTypes } from './PaymentMethodTypes';

export class CardSuccessfulPaymentResponseModel {
    public paymentMethodType: PaymentMethodTypes = PaymentMethodTypes.Card;

    public vendorTxCode: string;
}